import React from 'react';
import { connect } from 'react-redux';

import {
  ModalForm, TextField, FormItemRow, Intl, FormActionsBtns,
} from 'components';
import ParticipantService from 'api/Participant';
import SettingsActions from 'store/reducers/Settings';
import {
  composeValidators, equalTo, required,
} from 'config/InputErrors';
import { useSubmit } from 'hooks';

const ChangePasswordModal = ( {
  entityId, open, onClose, onConfirm, toggleLoading,
} ) => {
  const submitForm = useSubmit( {
    promise: ( dataToSend ) => ParticipantService.updateParticipant( entityId, dataToSend ),
    format: ( dataToFormat ) => ( { plainPassword: dataToFormat.plainPassword } ),
    toggleLoading,
    callback: onConfirm,
  } );

  return (
    <ModalForm
      showErrorsInHeader
      open={open}
      size="md"
      onClose={onClose}
      onSubmit={submitForm}
      footer={( <FormActionsBtns saveLabel="save" onClickCancel={onClose} /> )}
      body={() => (
        <>
          <FormItemRow
            title="newPassword"
            titleSize={5}
            field={(
              <TextField
                field="plainPassword"
                type="password"
                formGroupClass="m-0"
                validate={required}
              />
            )}
          />
          <FormItemRow
            title="passwordConfirmation"
            titleSize={5}
            field={(
              <TextField
                field="passwordConfirmation"
                type="password"
                formGroupClass="m-0"
                validate={composeValidators( required, equalTo( 'plainPassword' ) )}
                validateTranslateValues={{ label: <Intl id="newPassword" /> }}
              />
            )}
          />
        </>
      )}
    />
  );
};

const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( ChangePasswordModal );
